import { createContext, useContext } from 'react'

export type SchedulingWizardCallbacks = {
  onLeadAutoClosed?: () => void
}

export const SchedulingWizardCallbacksContext =
  createContext<SchedulingWizardCallbacks>({})

export function useSchedulingWizardCallbacks() {
  return useContext(SchedulingWizardCallbacksContext)
}
